import { actionConstants } from '../actions/actionConstants';

const initState = {
  loading: false,
  isSubmitting: false,
  alarmList: [],
  mAlarmList: [],
  getAlarmListError: '',
  availableGroups: [],
  getAvailableGroupsError: '',
  availableGroupsSummaries: [],
  trend: [],
  getTrendError: '',
  addNoteError: '',
  errors: '',
};

const dashboardReducer = (state = initState, action) => {
  var _state = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case actionConstants.START_QUERY:
      return { ...state, errors: '', loading: true };
    case actionConstants.END_QUERY:
      return { ...state, loading: false };
    case actionConstants.START_SUBMISSION:
      return { ...state, errors: '', isSubmitting: true };
    case actionConstants.END_SUBMISSION:
      return { ...state, isSubmitting: false };
    case actionConstants.GET_ALARM_LIST_SUCCESS:
      return { ...state, alarmList: action.data };
    case actionConstants.GET_ALARM_LIST_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ALARM_LIST_BY_MC_SUCCESS:
      return { ...state, mAlarmList: action.data };
    case actionConstants.GET_ALARM_LIST_BY_MC_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_AVAILABLE_GROUPS_SUCCESS:
      return { ...state, availableGroups: action.data };
    case actionConstants.GET_AVAILABLE_GROUPS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_AVAILABLE_GROUPS_SUMMARIES_SUCCESS:
      return { ...state, availableGroupsSummaries: action.data };
    case actionConstants.GET_AVAILABLE_GROUPS_SUMMARIES_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_TREND_SUCCESS:
      return { ...state, trend: action.data };
    case actionConstants.GET_TREND_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.ADD_NOTE_SUCCESS:
      return _state;
    case actionConstants.ADD_NOTE_FAILURE:
      _state.addNoteError = action.data;
      return _state;
    default:
      return _state;
  }
};
export default dashboardReducer;
